/*
 * @Author: Chao Yang
 * @Date: 2021-06-09 06:01:04
 * @LastEditor: Chao Yang
 * @LastEditTime: 2022-12-15 15:45:01
 */
export const environment = {
  production: true,
  feature: {
    openExtraDocumentViewer: false,
    myInvestmentGroupby: false,
    enableNewDocumentWidget: false,
    enableOfferingsNoFundsText: false,
    showDataSetting: false,
    enableInvestorEmailSearch: false,
    useGlobalValues: false,
    useNewDateRangeComponent: false,
    useOneYearDefaultDocumentRange: false,
    dashboardAggregateNavToggle: false,
    myInvestmentCommitmentTrackerDisplay: false,
    enableAggregateDataToggleButton: false,//US38913 IP: Add toggle for $/ % on donut charts
    investmentDetailWarning: false,
    dataRoom: false,
    newTrackRecord: true,
    showDataSettingAllInvestors: false,
    investmentDetailMenu: false,
    documentNameVisible: true,
    displayClosedAccount: false,
    feature2024_4: false,
    myInvestmentConfigurability: false,
    newApi: false,
    drakeFundType: false,
    fundDataSourceEnabled: false
  },
  dsfApiPath: '',
  update(features) {
    this.feature.showDataSetting = features.investorPortalPhase1_6;
    this.feature.enableInvestorEmailSearch = features.investorPortal2023_2;
    this.feature.useOneYearDefaultDocumentRange = features.investorPortal2023_2;
    this.feature.dashboardAggregateNavToggle = features.investorPortal2023_2;
    this.feature.myInvestmentCommitmentTrackerDisplay = features.investorPortal2023_2;
    this.feature.enableAggregateDataToggleButton = features.investorPortal2023_2;
    this.feature.useGlobalValues = features.investorPortal2023_3;
    this.feature.useNewDateRangeComponent = features.investorPortal2024_4;
    this.feature.openExtraDocumentViewer = features.investorPortalPhase1_7;
    this.feature.myInvestmentGroupby = features.investorPortalPhase1_7;
    this.feature.enableNewDocumentWidget = features.investorPortalPhase1_7;
    this.feature.enableOfferingsNoFundsText = features.investorPortalPhase1_7;
    this.feature.dataRoom = features.investorPortalPhase1_7;
    this.feature.newTrackRecord = features.investorPortalPhase1_7;
    this.feature.investmentDetailWarning = features.investorPortalPhase1_7;
    this.feature.showDataSettingAllInvestors = features.investorPortalPhase1_7;
    this.feature.investmentDetailMenu = features.investorPortalPhase1_7;
    this.feature.documentNameVisible = true;
    this.feature.displayClosedAccount = features.investorPortal2024_4;
    this.feature.feature2024_4 = features.feature2024_4;
    this.feature.myInvestmentConfigurability = false;
  },
  assetsPath: 'InvestorPortal/',
};
